export default [
    { path: '/asiaexpo/:locale?', name: 'home', component: () => import('@/views/general/Home')},
    { path: '*', name: 'not-found', component: () => import('@/views/general/Home') },
]
